import React from "react";
import { useDialog } from "../../../context";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StyledButton from "../StyledButton";
import StyledDialog from "./StyledDialog";

const InfoDialog = () => {
  const { info, hideInfo } = useDialog();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const handleClose = () => {
    if (!!info.close) {
      info.close();
    }
    hideInfo();
  };
  return (
    <React.Fragment>
      <StyledDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullScreen={fullScreen}
        open={!!info}
      >
        <DialogTitle x={{ m: 0, p: 2 }} id="customized-dialog-title">
          Info
        </DialogTitle>
        <DialogContent sx={{ width: 400 }} dividers>
          <Typography sx={{ textAlign: "center" }} gutterBottom>
            {info?.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <StyledButton variant="contained" onClick={handleClose}>
            Ok
          </StyledButton>
        </DialogActions>
      </StyledDialog>
    </React.Fragment>
  );
};

export default InfoDialog;
